module.exports = __webpack_public_path__ + "static/media/faqBalance-en-ar.db066acc.vtt";